import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Button from 'eventbrite_design_system/button/Button';
import {
    TYPE_LINK,
    STYLE_ANCHOR,
} from 'eventbrite_design_system/button/constants';
import Divider from 'eventbrite_design_system/divider/Divider';
import Icon from 'eventbrite_design_system/icon/Icon';
import TrendingSvg from 'eventbrite_design_system/iconography/icons/Trending';

import {HAS_WINDOW} from 'eventbrite_design_system/utils/dom';
import Paginator from './SearchPaginator';

const TrendingSearchesAnchor = ({trendingSearchData}) => {
    let component = null;

    if (trendingSearchData) {
        const trendingSearchesAnchorClasses = classNames(
            'search-footer__trending-searches',
            'eds-align--center',
            'eds-l-pad-vert-10',
            'eds-l-md-pad-vert-16',
            'eds-l-mw-pad-vert-16',
            'eds-l-ln-pad-vert-16',
            'eds-l-lg-pad-vert-16',
            'eds-l-lw-pad-vert-16',
        );

        component = (
            <div className={trendingSearchesAnchorClasses}>
                <Button
                    type={TYPE_LINK}
                    style={STYLE_ANCHOR}
                    href={trendingSearchData.path}
                >
                    <span className="eds-l-mar-right-1">
                        <Icon type={<TrendingSvg />} />
                    </span>
                    {trendingSearchData.text}
                </Button>
            </div>
        );
    }

    return component;
};

export default class SearchFooter extends React.PureComponent {
    static propTypes = {
        handleGetPage: PropTypes.func.isRequired,
        currentPage: PropTypes.number,
        isNextDisabled: PropTypes.bool,
        firstPageUrl: PropTypes.string,
        lastPageUrl: PropTypes.string,
        pageCount: PropTypes.number,
        hasEventResults: PropTypes.bool,
        //eslint-disable-next-line
        trendingSearchData: PropTypes.object,
        //eslint-disable-next-line
        history: PropTypes.object,
        nextPageUrl: PropTypes.string,
        prevPageUrl: PropTypes.string,
    }

    _onGetPage = (pageNumber) => {
        const {handleGetPage, history} = this.props;

        if (HAS_WINDOW) {
            window.scrollTo(0, 0);
        }

        handleGetPage(pageNumber, history);
    }

    render() {
        const {
            currentPage,
            isNextDisabled,
            nextPageUrl,
            prevPageUrl,
            firstPageUrl,
            pageCount,
            lastPageUrl,
            trendingSearchData,
            hasEventResults,
        } = this.props;

        let searchFooter = null;

        const footerCalloutLinks = (
            <div>
                <TrendingSearchesAnchor trendingSearchData={trendingSearchData} />
            </div>
        );

        if (hasEventResults) {
            searchFooter = (
                <div>
                    <div className="destination-search-footer eds-l-mar-bot-10 eds-l-mar-top-10 eds-l-mar-left-3">
                        <Paginator
                            currentPage={currentPage}
                            handleGetPage={this._onGetPage}
                            isNextDisabled={isNextDisabled}
                            nextUrl={nextPageUrl}
                            prevUrl={prevPageUrl}
                            firstPageUrl={firstPageUrl}
                            lastPageUrl={lastPageUrl}
                            pageCount={pageCount}
                        />
                    </div>
                    <div className="eds-l-pad-hor-3">
                        <Divider color="grey-300" />
                    </div>
                    {footerCalloutLinks}
                </div>
            );
        }

        return (
            <footer className="search-footer">
                {searchFooter || footerCalloutLinks}
            </footer>
        );
    }
}
